export default __webpack_public_path__ + "static/media/Rodolfo2.c4b7d537.png";